export const portraitUrl =
  'https://cdn.magicpatterns.com/uploads/jBSnycc8RBjQHRfsT8XPDw/MUHEEZ_FIRST_ORDER-Picsart-AiImageEnhancer.jpg'

export const professionalTitle =
  'Career Advising Specialist · Certified Resume Writer · Certified Interview Coach · Certified Digital Career Strategist'

export const navItems = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Advisory Services' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
]

export const contactDetails = {
  email: 'tomvecchione.career@gmail.com',
  linkedin: 'https://www.linkedin.com/in/tvecchione',
  linkedinLabel: 'linkedin.com/in/tvecchione',
  location: 'Woodstock, Georgia, United States',
  availability: 'In-person and virtual consultations, Monday–Friday',
}

export const credentials = [
  {
    abbr: 'Ph.D.',
    short: 'Doctorate',
    name: 'Doctor of Philosophy, Counselor Education',
    description:
      'Doctoral training in human development, career theory, and behavioral assessment — the scientific foundation behind every engagement.',
  },
  {
    abbr: 'CPRW',
    short: 'Resume Writer',
    name: 'Certified Professional Resume Writer',
    description:
      'Nationally recognized certification in strategic resume development, ATS architecture, and executive positioning.',
  },
  {
    abbr: 'CIC',
    short: 'Interview Coach',
    name: 'Certified Interview Coach',
    description:
      'Credentialed expertise in behavioral interview strategy, executive presence, and offer-stage preparation.',
  },
  {
    abbr: 'CDCS',
    short: 'Digital Strategist',
    name: 'Certified Digital Career Strategist',
    description:
      'Specialized training in LinkedIn optimization, digital brand alignment, and executive search visibility.',
  },
]

export const metrics = [
  { value: '25+', unit: 'Years', label: 'Executive & institutional career leadership' },
  { value: '1,150+', unit: 'Clients', label: 'Mid-level & executive careers transformed' },
  { value: '3×', unit: 'Certified', label: 'CPRW · CIC · CDCS credentialed expertise' },
  { value: 'Ph.D.', unit: '', label: 'Counselor Education, with published industry research' },
]

export const institutions = ['Kennesaw State University', 'University of the Pacific', 'Elon University']
